import BasicRepository, { AllArgs } from "./basicRepository";
import Client from "../client";
import {
    NonVcsRunbookResource,
    DeploymentPromotionTarget,
    RunbookSnapshotTemplateResource,
    RunbookRunPreviewResource,
    ResourceCollection,
    RunbookSnapshotResource,
    RunbookRunTemplateResource,
    EnvironmentResource,
    NewNonVcsRunbookResource,
} from "client/resources";
import { RouteArgs } from "client/resolver";

type RunbookRepositoryListArgs = {
    skip?: number;
    take?: number;
    orderBy?: string;
} & RouteArgs;

type RunbookRepositoryAllArgs = {
    projectIds?: string[];
} & AllArgs;

class RunbookRepository extends BasicRepository<NonVcsRunbookResource, NewNonVcsRunbookResource, RunbookRepositoryListArgs, RunbookRepositoryAllArgs> {
    constructor(client: Client) {
        super("Runbooks", client);
    }
    getRunbookSnapshotTemplate(runbook: NonVcsRunbookResource): Promise<RunbookSnapshotTemplateResource> {
        return this.client.get<RunbookSnapshotTemplateResource>(runbook.Links["RunbookSnapshotTemplate"]);
    }
    getRunbookRunTemplate(runbook: NonVcsRunbookResource): Promise<RunbookRunTemplateResource> {
        return this.client.get<RunbookRunTemplateResource>(runbook.Links["RunbookRunTemplate"]);
    }
    getRunbookRunPreview(promotionTarget: DeploymentPromotionTarget) {
        return this.client.get<RunbookRunPreviewResource>(promotionTarget.Links["RunbookRunPreview"], { includeDisabledSteps: true });
    }
    getRunbookSnapshots(runbook: NonVcsRunbookResource, args?: { skip?: number; take?: number } & RouteArgs): Promise<ResourceCollection<RunbookSnapshotResource>> {
        return this.client.get<ResourceCollection<RunbookSnapshotResource>>(runbook.Links["RunbookSnapshots"], args);
    }
    getRunbookEnvironments(runbook: NonVcsRunbookResource): Promise<EnvironmentResource[]> {
        return this.client.get<EnvironmentResource[]>(runbook.Links["RunbookEnvironments"]);
    }
}

export default RunbookRepository;
